import Home from "./Pages/Home";
import AllTransactions from "./Pages/AllTransactions";
import { Routes, Route } from "react-router-dom";

function App() {
  console.log("renderd");
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="alltransactions" element={<AllTransactions />} />
    </Routes>
  );
}

export default App;
